import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
  Spinner,
  Toast,
  ToastHeader,
  ToastBody,
  Collapse
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb_old";
import SimpleBar from "simplebar-react";
import List from "list.js";
// Import Flatepicker
import Flatpickr from "react-flatpickr";
import { Client, Account, Databases } from "appwrite";
import axios from "axios";

// Import Images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../assets/images/users/avatar-4.jpg";
import avatar5 from "../../assets/images/users/avatar-5.jpg";
import { withTranslation } from "react-i18next";
import getFrenchTag from "../../helpers/local_text_helper";
import { Link, useNavigate } from "react-router-dom";
import classnames from "classnames";
import logo_maaia from "../../assets/images/companies/img-3.png";
import AllAlerts from "./AllAlerts";

export const fakeAlertList = [
  {
    $id: "Erh7rR389g6Js9e87Mf698",
    title: "Manque d'Information",
    message:
      "Plusieurs e-mails concernant les options de personnalisation avancées des bijoux n'ont pas pu être traités efficacement en raison du manque de détails  dans le centre de ressources.Il est recommandé d'enrichir les informations disponibles pour Synibox sur ce sujet.",
    $createdAt: "2023-12-15T08:00:00.000Z"
  },
  {
    $id: "Srt9h0P6r87egTazef789J69re8g7",
    title: "Langues Non Prises en Charge",
    message:
      "Il y a eu une augmentation des demandes en langues non prises en charge par Synibox, notamment en italien et en portugais. Envisagez d'ajouter ces langues pour mieux servir cette clientèle",
    $createdAt: "2024-01-10T08:00:00.000Z"
  },
  {
    $id: "L66h8Terg7G5erg7reJe9rgerLerg7",
    title: "Questions Techniques Spécifiques",
    message:
      "Des questions techniques liées à l'entretien des bijoux et aux matériaux utilisés n'ont pas été traitées de manière optimale. Il serait bénéfique d'ajouter des informations techniques détaillées pour que Synibox puisse répondre plus précisément à ces demandes",
    $createdAt: "2024-02-05T08:00:00.000Z"
  },
  {
    $id: "J36dg46U76g78eH3er4fl",
    title: "Réclamations et Retours",
    message:
      "Des difficultés ont été rencontrées dans la gestion des e-mails relatifs aux réclamations et aux retours. Un examen des procédures actuelles et une mise à jour des directives pour Synibox pourraient améliorer la gestion de ces cas",
    $createdAt: "2024-03-20T08:00:00.000Z"
  },
  {
    $id: "4drf7h9rt8896sr3sg6zge",
    title: "Suivi des Commandes Internationales",
    message:
      "Des interrogations récurrentes concernant le suivi des commandes à internationales nécessitent d'ajouter d'avantage d'informations dans le centre de ressource à ce sujet",
    $createdAt: "2024-04-10T08:00:00.000Z"
  },
  {
    $id: "87h6r8t7h6GF",
    title: "Manque d'Information",
    message:
      "Certains clients signalent un manque d'informations concernant les délais de livraison des commandes personnalisées. Assurez-vous que toutes les informations pertinentes sont disponibles pour éviter toute confusion.",
    $createdAt: "2024-01-25T08:00:00.000Z"
  },
  {
    $id: "Ef87zr7g9rg7e78rga7",
    title: "Langues Non Prises en Charge",
    message:
      "De nouveaux clients venant de pays francophones signalent qu'ils ne trouvent pas le site Synibox dans leur langue. Considérez l'ajout du français comme langue supportée pour mieux les servir.",
    $createdAt: "2024-02-15T08:00:00.000Z"
  },
  {
    $id: "q69e978reg654g",
    title: "Questions Techniques Spécifiques",
    message:
      "Certains clients demandent des informations détaillées sur les processus de fabrication des bijoux. Il serait utile de fournir des explications plus approfondies pour répondre à leurs besoins.",
    $createdAt: "2024-03-05T08:00:00.000Z"
  },
  {
    $id: "xc6354bh6df5",
    title: "Réclamations et Retours",
    message:
      "Un client a signalé des difficultés lors du processus de retour d'un article défectueux. Revoyez les instructions de retour pour garantir une expérience sans tracas pour les clients.",
    $createdAt: "2024-04-01T08:00:00.000Z"
  }
];
const AlertTable = (props) => {
  const messages = props.message;
  const alertList = props.alerts;
  // setAlertList(props.alerts);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingAlertId, setLoadingAlertId] = useState(null);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [modal_center, setmodal_center] = useState(false);

  function tog_center() {
    setmodal_center(!modal_center);
  }

  function changeColor(tag) {
    switch (tag) {
      case "product":
        return "primary";
      case "product_availability":
        return "primary";
      case "product_advice":
        return "primary";
      case "product_problems":
        return "danger";
      case "product_price":
        return "primary";
      case "promotions":
        return "primary";
      case "order_process":
        return "primary";
      case "order":
        return "danger";
      case "payments":
        return "danger";
      case "refunds":
        return "danger";
      case "disputes":
        return "danger";
      case "billing":
        return "warning";
      case "delivery":
        return "danger";
      case "returns":
        return "warning";
      case "customer_account":
        return "info";
      case "password":
        return "info";
      case "security":
        return "info";
      case "privacy":
        return "info";
      case "customer_data":
        return "info";
      case "after_sales":
        return "info";
      case "technical_problems":
        return "primary";
      case "website_feedback":
        return "info";
      case "special_programs":
        return "info";
      case "affiliation":
        return "info";
      case "customer_loyalty":
        return "info";
      case "feedback":
        return "info";
      case "complaints":
        return "warning";
      case "company_information":
        return "info";
      case "ethics_social_responsibility":
        return "info";
      case "subscription_management":
        return "info";
      case "store_services":
        return "info";
      case "influencers":
        return "info";
      case "content_creators":
        return "info";
      case "spam":
        return "warning";
      case "other":
        return "info";
      default:
        return "warning";
    }
  }

  function gotosetting() {
    navigate("/resources");
  }

  async function deleteMessage(messageId) {
    console.log("deleteMessage", messageId);

    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    try {
      await databases.deleteDocument("alert", messageId);
      console.log("Message deleted successfully");
      props.setAlertList(
        alertList.filter((message) => message.$id !== messageId)
      );
    } catch (error) {
      console.log("Error deleting message:", error);
    }
  }

  const fetchMails = async function (message_id) {
    onLoading(true);
    setLoadingAlertId(message_id);
    const makeApiRequest = async function (apiUrl, folder) {
      axios
        .get(apiUrl, {
          params: {
            company_id: localStorage.getItem("companyId"),
            message_id: message_id,
            folder
          }
        })
        .then(async (response) => {
          console.log("response.mailsss", response.mails.length);
          onLoading(false);
          const test = [];
          if (test.length) {
            goToMessageReadView(response.mails[0]);
          } else {
            console.log("listMails error");
            setToastMessage("Erreur.");
            tog_center();
          }
          // if (response.mails.length) {
          //     goToMessageReadView(response.mails[0])
          // } else {
          //     console.log("listMails");
          //     setToastMessage("Erreur.");
          //     tog_center();
          // }
        })
        .catch((error) => {
          console.log("response.mailsss error", error);
          console.log(JSON.stringify(error));
          onLoading(false);
        });
    };

    const apiUrl = "https://mailbox.semecloud.tech/get-single-mail";
    // const apiUrl = "http://localhost:55000/get-threads";
    await makeApiRequest(apiUrl, "INBOX");
  };

  function goToMessageReadView(message) {
    // console.log("the_folder props data is: ", message);
    navigate("/read-email", {
      replace: false,
      state: { the_message: message, all_messages: messages, folder: "INBOX" }
    });
  }

  const onLoading = (val) => {
    setLoading(val);
    setLoadingAlertId(null); // Arrêtez le chargement
  };

  const toggleToast = () => {
    console.log("setToast before: " + toast);
    setToast(!toast);
    console.log("setToast after: " + toast);

    setTimeout(() => {
      if (toast) {
        setToast(!toast);
      }
    }, 3000);
  };
  async function updateAlert(alert_id) {
    console.log("updateAlert", alert_id);
    const client = new Client();
    const databases = new Databases(client, "default");
    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);
    try {
      await databases.updateDocument("default", "alert", alert_id, {
        active: false
      });
      console.log("Alert deleted successfully");
      props.setAlertList(alertList.filter((alert) => alert.$id !== alert_id));
      setExpandedAlert(undefined);
      console.log(
        "updated alerts",
        alertList.filter((alert) => alert.$id !== alert_id)
      );
    } catch (error) {
      console.log("Error updating alert:", error);
    }
  }
  const svgs = {
    info_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <circle cx="7.68479" cy="7.68479" r="7.68479" fill="#F10944" />
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }} /// La bonne méthode
          d="M7.70362 5.1598C8.06741 5.1598 8.36231 4.86489 8.36231 4.5011C8.36231 4.13732 8.06741 3.84241 7.70362 3.84241C7.33983 3.84241 7.04492 4.13732 7.04492 4.5011C7.04492 4.86489 7.33983 5.1598 7.70362 5.1598ZM7.70362 6.03778C7.33983 6.03778 7.04492 6.33268 7.04492 6.69647V10.6487C7.04492 11.0124 7.33983 11.3073 7.70362 11.3073C8.06741 11.3073 8.36231 11.0124 8.36231 10.6487V6.69647C8.36231 6.33268 8.06741 6.03778 7.70362 6.03778Z"
          fill="#F7F8FB"
        />
      </svg>
    ),
    multiple_action_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          d="M13.6431 0.22995L13.8549 0.172949C14.7141 -0.0286044 15.605 -0.0542117 16.4737 0.0972837L16.8441 0.172946C18.0875 0.464606 19.0816 1.39292 19.4691 2.64311L19.5261 2.855C19.7276 3.71419 19.7532 4.60494 19.5964 5.50205L19.5261 5.84406C19.2345 7.08745 18.3061 8.08157 17.0559 8.46907L16.8441 8.52607C15.9849 8.72762 15.094 8.75323 14.1969 8.59636L13.8549 8.52607C12.6115 8.23441 11.6174 7.30611 11.2299 6.05591L11.1729 5.84402C10.9424 4.86102 10.9424 3.838 11.1729 2.85496C11.4646 1.61157 12.3929 0.61745 13.6431 0.22995ZM16.4147 2.12625L16.1293 2.06752C15.5261 1.96232 14.9074 1.9801 14.345 2.1114L14.2013 2.14985C13.6613 2.31751 13.2488 2.75928 13.1192 3.31158C12.9592 3.99424 12.9592 4.7047 13.1106 5.35311L13.149 5.49682C13.3167 6.0368 13.7584 6.44932 14.2826 6.5727L14.568 6.63143C15.1713 6.73663 15.7899 6.71885 16.3523 6.58755L16.496 6.54909C17.036 6.38143 17.4485 5.93967 17.5719 5.41557L17.6306 5.13017C17.7358 4.52687 17.718 3.90826 17.5867 3.34583L17.5483 3.20213C17.3806 2.66215 16.9389 2.24963 16.4147 2.12625ZM2.85493 0.172947L2.64308 0.22995C1.39289 0.617444 0.464594 1.61155 0.172938 2.85494C-0.0576455 3.83798 -0.0576455 4.86104 0.172937 5.84407L0.229942 6.05593C0.617437 7.30612 1.61155 8.23442 2.85494 8.52608L3.19691 8.59636C4.09406 8.75323 4.98485 8.72762 5.84408 8.52607L6.05592 8.46907C7.30611 8.08158 8.23441 7.08747 8.52607 5.84408L8.59636 5.50211C8.75322 4.60495 8.72762 3.71416 8.52607 2.85494L8.46906 2.64309C8.08157 1.3929 7.08746 0.464602 5.84407 0.172945L5.47372 0.0972833C4.60495 -0.054211 3.71415 -0.0286046 2.85493 0.172947ZM5.1293 2.06752L5.41469 2.12625C5.93886 2.24963 6.38062 2.66214 6.54827 3.20214L6.58673 3.34585C6.71803 3.90829 6.73581 4.52685 6.63061 5.13012L6.57188 5.41551C6.4485 5.93968 6.03599 6.38144 5.49599 6.54909L5.35228 6.58755C4.78984 6.71885 4.17128 6.73663 3.56801 6.63143L3.28262 6.5727C2.75845 6.44932 2.31669 6.03681 2.14904 5.49681L2.11058 5.3531C1.95912 4.70468 1.95912 3.99426 2.11924 3.31164C2.24881 2.75927 2.66132 2.31751 3.20132 2.14986L3.34503 2.1114C3.90747 1.9801 4.52603 1.96232 5.1293 2.06752ZM2.85499 11.1729L2.6431 11.2299C1.39291 11.6174 0.464598 12.6115 0.172938 13.8549C-0.0576461 14.8379 -0.0576461 15.8611 0.172938 16.8441L0.229943 17.0559C0.617442 18.3061 1.61156 19.2345 2.85495 19.5261L3.19697 19.5964C4.09407 19.7532 4.98482 19.7276 5.84401 19.5261L6.05591 19.4691C7.3061 19.0816 8.23441 18.0875 8.52607 16.8441L8.59636 16.5021C8.75322 15.605 8.72762 14.7141 8.52606 13.8549L8.46906 13.6431C8.08156 12.3929 7.08744 11.4646 5.84405 11.1729L5.47367 11.0973C4.60493 10.9458 3.71418 10.9714 2.85499 11.1729ZM5.12935 13.0675L5.41475 13.1263C5.93885 13.2496 6.38062 13.6621 6.54827 14.2021L6.58673 14.3459C6.71803 14.9083 6.73581 15.5269 6.63061 16.1301L6.57188 16.4155C6.4485 16.9397 6.03598 17.3815 5.496 17.5491L5.35229 17.5876C4.78987 17.7188 4.17126 17.7366 3.56796 17.6314L3.28256 17.5727C2.75846 17.4493 2.31669 17.0368 2.14904 16.4968L2.11058 16.3531C1.95912 15.7047 1.95912 14.9942 2.11924 14.3116C2.24881 13.7593 2.66133 13.3175 3.20131 13.1498L3.34501 13.1114C3.90744 12.9801 4.52605 12.9624 5.12935 13.0675ZM13.855 11.1729L13.6431 11.2299C12.3929 11.6174 11.4646 12.6116 11.1729 13.855C10.9424 14.838 10.9424 15.8611 11.1729 16.844L11.2299 17.0559C11.6174 18.3061 12.6116 19.2345 13.855 19.5261L14.197 19.5964C15.0941 19.7532 15.9849 19.7276 16.844 19.5261L17.0559 19.4691C18.3061 19.0816 19.2344 18.0875 19.5261 16.8441L19.5964 16.5021C19.7532 15.605 19.7276 14.7142 19.5261 13.855L19.4691 13.6431C19.0816 12.3929 18.0874 11.4646 16.8441 11.1729L16.4737 11.0973C15.6049 10.9458 14.7142 10.9714 13.855 11.1729ZM16.1294 13.0675L16.4147 13.1262C16.9389 13.2496 17.3806 13.6621 17.5483 14.2021L17.5867 14.3458C17.718 14.9082 17.7358 15.5269 17.6306 16.1302L17.5719 16.4156C17.4485 16.9397 17.036 17.3815 16.496 17.5491L16.3523 17.5876C15.7899 17.7188 15.1713 17.7366 14.568 17.6314L14.2826 17.5727C13.7585 17.4493 13.3167 17.0368 13.149 16.4968L13.1106 16.3531C12.9592 15.7047 12.9592 14.9942 13.1192 14.3116C13.2488 13.7593 13.6613 13.3175 14.2013 13.1498L14.345 13.1114C14.9074 12.9801 15.5261 12.9624 16.1294 13.0675Z"
          fill="#563BFF"
        />
      </svg>
    )
  };
  const [expandedAlert, setExpandedAlert] = useState(undefined);

  const onExpandedAlert = (id) => {
    setExpandedAlert(id);
  };

  const stringToColour = (str) => {
    let hash = 0;
    str.split("").forEach((char) => {
      hash = char.charCodeAt(0) + ((hash << 5) - hash);
    });
    let colour = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      colour += value.toString(16).padStart(2, "0");
    }

    // Vérifiez si la couleur générée est dans la plage de jaune
    if (/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(colour)) {
      const hexValue = colour.replace("#", "");
      const r = parseInt(hexValue.slice(0, 2), 16);
      const g = parseInt(hexValue.slice(2, 4), 16);
      const b = parseInt(hexValue.slice(4, 6), 16);

      // YELLOW
      if (r >= 200 && g >= 200 && b < 100) {
        colour = "#FF5733";
      }

      // WHITE
      const whiteThreshold = 200;
      if (r >= whiteThreshold && g >= whiteThreshold && b >= whiteThreshold) {
        colour = "#333333";
      }
    }

    return colour;
  };

  const handleNotificationConsult = (alert) => {
    // console.log({ message_id: alert.client_message_id });
    handleNavigate("/mailbox", { id: alert.client_message_id });
  };
  const handleNavigate = (url, state) => {
    // Remplacez cela par la valeur que vous souhaitez passer
    navigate(url, {
      replace: true,
      state: state
    });
  };

  const [selected, setSelected] = useState(1);

  return (
    <React.Fragment>
      <Container fluid className="h-100" style={{ padding: "0" }}>
        <Row className="h-100">
          <Card
            style={{
              background: "transparent",
              boxShadow: "none",
              padding: "0px",
              marginBottom: "0"
            }}
          >
            <CardBody
              className="d-flex flex-column"
              style={{
                padding: "0"
              }}
            >
              {/* <div
                className="accordion accordion-flush px-0 font-primary"
                id="accordionFlushExample"
                style={{
                  flex: "1",
                  overflow: "auto",
                  maxHeight: "660.483px",
                  overflowY: "auto",
                }}>
                {alertList.length > 0 ? (
                  alertList.slice(0, 6).map((alert, alert_index) => (
                    <div key={alert_index} className={`accordion-item ${expandedAlert === alert.$id && "deployed"}`}>
                      <h2 className="accordion-header" id={`headingFlush` + alert_index}>
                        <div
                          className={classnames("accordion-button", "fw-medium", "font-primary", {
                            collapsed: expandedAlert !== alert.$id,
                          })}
                          type="button"
                          onClick={() => {
                            if (expandedAlert === alert.$id) {
                              onExpandedAlert(false);
                            } else {
                              onExpandedAlert(alert.$id);
                            }
                          }}
                          style={{ cursor: "pointer" }}>
                          <div className="title w-100">
                            {alert.message}
                            <br />
                            <span style={{ textTransform: "capitalize", fontWeight: "300", fontSize: "12px" }}>{formatDate(alert.$createdAt)}</span>
                          </div>
                        </div>
                      </h2>

                      <Collapse isOpen={expandedAlert === alert.$id} className="accordion-collapse">
                        <div className="accordion-body">
                          <div className="text-muted accordion-body__text font-primary">
                            {alert.message}
                            <Col lg={4}>
                              {alert.contact_reasons &&
                                alert.contact_reasons.map((reason, index) => (
                                  <div
                                    key={index}
                                    className={`badge me-1 font-primary`}
                                    style={{
                                      backgroundColor: `${stringToColour(reason)}25`,
                                      color: stringToColour(reason),
                                      font: "normal 400 11px / normal Poppins, sans-serif !important",
                                      marginTop: "6px",
                                      display: "flex !important",
                                    }}>
                                    {props.t(reason)}
                                  </div>
                                ))}
                            </Col>
                          </div>
                          <div className="">
                            <button
                              className="action-btn font-primary"
                              style={{
                                backgroundColor: "black",
                                marginRight: "20px",
                              }}
                              onClick={() => {
                                handleNotificationConsult(alert);
                              }}>
                              {props.t("Consulter")}
                            </button>
                            {alert.type === "missing_data" && (
                              <button
                                className="action-btn font-primary"
                                style={{
                                  background: "#563BFF",
                                  marginRight: "20px",
                                }}
                                onClick={() => {
                                  handleNavigate("/resources", { alert_id: alert.$id });
                                }}>
                                {props.t("Valider")}
                              </button>
                            )}
                            <button
                              className="action-btn font-primary"
                              style={{
                                backgroundColor: "#FF7049",
                                boxShadow: "0px 14.34494px 36.887px 0px rgba(255, 73, 73, 0.20)",
                              }}
                              onClick={() => updateAlert(alert.$id)}>
                              {props.t("Fermer")}
                            </button>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                  ))
                ) : (
                  <div className="h-100 d-flex flex-column align-items-center justify-content-center">
                    <div className="font-size-22 color-black font-primary">{props.t("Les statistiques seront visibles après 30 emails")}</div>
                    <img src={logo_maaia} height={40} />
                  </div>
                )}
              </div> */}
              <AllAlerts from_dashboard={props.from_dashboard} />
              {alertList.length > 0 && (
                <button
                  className="attention_requested-button mx-auto primary-button d-flex align-items-center font-primary"
                  onClick={() => {
                    navigate("/dashboard/attentions-requested");
                  }}
                >
                  {props.t("Voir toutes les attentions")}
                </button>
              )}
            </CardBody>
          </Card>
        </Row>
      </Container>

      <Modal
        isOpen={modal_center}
        toggle={() => {
          tog_center();
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0 font-primary">Erreur</h5>
          <button
            type="button"
            onClick={() => {
              setmodal_center(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="text-center">
            <div className="mb-4">
              <i className="mdi mdi-close-circle-outline text-danger display-4" />
            </div>
            <div>
              <h5 className="font-primary">Connexion échouer</h5>
              <p className="text-muted font-primary">
                No information in the message
              </p>
            </div>
          </div>
        </div>
      </Modal>
      <div
        className="position-fixed bottom-0 end-0 p-3"
        style={{ zIndex: "11" }}
      >
        <Toast isOpen={toast}>
          <ToastHeader toggle={toggleToast}>
            {/* <img src={logo} alt="" className="me-2" height="18" /> */}
            iAssistant
          </ToastHeader>
          <ToastBody color="primary">{toastMessage}</ToastBody>
        </Toast>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(AlertTable);
